import React, { useState } from "react";
import InView from "react-intersection-observer";
import SmBannerImage from "../../images/flexprint-main-banner-image.png";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import LazyLoad from 'react-lazyload';

export default function FlexprintMainBanner() {
  const [isVisible, setisVisible] = useState(false);
  return (
    <div className="cs-page-main-banner-section section-gap fp-cs-main-banner">
      <div className="cs-banner-image d-flex align-end justify-center">
        <div className="container d-flex flex-wrap align-start justify-center">
            <img src={SmBannerImage} title="Internet of things" alt="iot" />
        </div>
      </div>
      <div className="cs-main-banner-detail">
        <div className="container">
          <InView as="div" className="row d-flex flex-wrap row-banner-title" onChange={(inView) => setisVisible(inView)}>
            <div className="col left-bar">
              <h1>{isVisible ? <HeaderAnim header="Transforming managed- printing with digital & IoT" /> : ""}</h1>
            </div>
            <div className="col right-bar">
              <h3>How we helped FlexTG(R) improve customer services and automate processes?</h3>
            </div>
          </InView>
          <div className="row d-flex flex-wrap align-v-center">
            <div className="col left-bar">
              <p>Strategy · IoT · Transformation · Engineering · Innovation</p>
            </div>
            <div className="col right-bar">
              {/*<Link className="button button-xsmall button-white-border" to="/contact/">Let's Chat</Link>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}